import styled from 'styled-components';
import { Typography, Form, Input, Transfer, Switch, Divider } from 'antd';

const { Text } = Typography;

export const BoxMessage = styled(Text)`
  float: left;
  font-size: 15px;
  color: var(--white-color);
`;

export const BorderNoneInput = styled(Input)`
  border: none;
  outline: none;
  font-size: 15px;
  &:hover,
  &:focus {
    border: none;
    outline: none;
    box-shadow: none;
  }
`;

export const FormItem = styled(Form.Item)`
  &.ant-form-item {
    width: 100%;
  }
  .ant-form-item-label label {
    font-size: 16px;
  }
  .ant-form-item-label > label {
    height: auto !important;
  }
  .ant-select-selection-search-input {
    font-size: 16px;
  }
  &.oddFormItem {
    width: 50%;
    padding-right: 30px;
    @media (max-width: 750px) {
      width: 100%;
      padding-right: 0px;
    }
  }
`;

export const RowWrapper = styled.div`
  display: flex;
  gap: 60px;
  @media (max-width: 750px) {
    & {
      flex-direction: column;
      gap: 0;
    }
  }
`;

export const FormHeader = styled.h2`
  margin-bottom: 20px;
`;
export const ModalFormContainer = styled.div`
  margin-bottom: 10px;
  height: auto;
  .ant-tabs .ant-tabs-tab {
    font-size: 16px;
  }
`;
export const FormSubmitButtonConatainer = styled.div`
  text-align: right;
`;

export const TransferDataBox = styled(Transfer)`
  .ant-btn-icon {
    display: none;
  }
  &.ant-transfer {
    overflow: auto;
  }
  .ant-btn > .anticon {
    margin-inline-start: 0px;
  }
  .ant-btn-primary.ant-btn-sm {
    height: 30px;
    width: 30px;
  }
  .ant-transfer-list-header {
    flex-direction: row-reverse;
    background-color: #1785d6;
    color: var(--white-color);
    background: var(--bg-button-default-color);
  }
`;
export const AntToggleButton = styled(Switch)`
  &.ant-switch-checked {
    background-color: var(--bg-dark-green-color) !important;
  }
`;
export const AntDivider = styled(Divider)`
  &.ant-divider {
    border-block-start: 3px solid rgba(5, 5, 5, 0.06);
  }
`;
